import {ButtonCommandService} from './button-command.service';
import {EventService} from './event.service';
import {MenuService} from './menu.service';
import {TabellenService} from './tabellen.service';
import {UiArtefaktService} from './ui-artefakt.service';
import {UiModelService} from './ui-model.service';
import {UiUpdateService} from './ui-update.service';
import {ValidationService} from './validation.service';
import {WertemengenService} from './wertemengen.service';
import {AutofillService} from './autofill.service';
import {DispatchService} from './dispatch.service';
import {ShellConfigService} from './shell-config.service';
import {MenuStateService} from './menu-state.service';
import {MenuWorkflowService} from './menu-workflow.service';
import {DialogListenerService} from './dialog-listener.service';
import {UiConfigService} from '@lv1871/core';
import {SanitizationService} from './sanitization.service';
import {AdressValidationService} from './adress-validation.service';
import {VermittlerdatenService} from './vermittlerdaten.service';
import {RisikofragenService} from './risikofragen.service';
import {AsyncUirefService} from './async-uiref.service';
import {FondsService} from './fonds.service';
import {AntragsdatenserviceRestService} from './rest/antragsdatenservice-rest.service';
import {ProcessRestService} from './rest/process-rest.service';
import {CalculationService} from './calculation.service';
import {StageConfigService} from './stage-config.service';
import {EventFondsService} from './event-fonds.service';

export const ALL_SERVICES = [
  ButtonCommandService,
  EventService,
  MenuService,
  TabellenService,
  UiArtefaktService,
  UiModelService,
  UiUpdateService,
  ValidationService,
  WertemengenService,
  AutofillService,
  DispatchService,
  ShellConfigService,
  MenuStateService,
  MenuWorkflowService,
  DialogListenerService,
  UiConfigService,
  SanitizationService,
  AdressValidationService,
  VermittlerdatenService,
  RisikofragenService,
  AsyncUirefService,
  FondsService,
  AntragsdatenserviceRestService,
  ProcessRestService,
  CalculationService,
  StageConfigService,
  EventFondsService
];
